import {useContext} from 'react';
import {StoreContext} from 'store/context';

export function useAppState(): AppState {
  return useContext(StoreContext).state;
}
